import styled from 'styled-components';
import { Breakpoints } from '@/styles/breakpoints';
import Block from '@shared/components/ui/Block';
import type theme from '@shared/theme';

export const CardInner = styled(Block)<{
    $backgroundColour?: keyof typeof theme.colors;
}>`
    padding: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.uNavy10};
    background-color: ${({ $backgroundColour, theme }) =>
        $backgroundColour ? theme.colors[$backgroundColour] : 'transparent'};

    &:last-child {
        border-bottom: none;
    }
`;

export const Card = styled(Block)<{
    $backgroundColor?: keyof typeof theme.colors;
    $borderColor?: keyof typeof theme.colors;
}>`
    background-color: ${({ $backgroundColor, theme }) =>
        $backgroundColor ? theme.colors[$backgroundColor] : theme.colors.white};
    border: solid 1px
        ${({ $borderColor, theme }) =>
            $borderColor ? theme.colors[$borderColor] : theme.colors.uNavy10};
    border-radius: 8px;
    padding: 20px;

    &:has(> ${CardInner}) {
        padding: 0;
    }

    /* @media (min-width: ${Breakpoints.Medium}) {
        padding: 30px;
    } */
`;
